import { Outlet } from 'react-router-dom';

export const UsersManagement = () => {
  return <Outlet />;
};
